module.exports = __webpack_public_path__ + "media/images/background/ccsanto-domingo-d54105eb90cc5cc0d1dd972779ddfd3e.png";